export default __webpack_public_path__ + "static/media/3026.88a3e0e0.jpg";